module.exports = __webpack_public_path__ + "media/images/samples/1280x768/1-cc28fb9f776268e7a27b938be9d79ed0.jpg";